"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _positionActions = require("../actions/positionActions");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var initialState = {
  positions: {},
  fetching: true
};
var _default = exports["default"] = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments.length > 1 ? arguments[1] : undefined,
    type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case _positionActions.REQUEST_ACCOUNT_POSITIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: true
      });
    case _positionActions.RECEIVE_ACCOUNT_POSITIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        fetching: false,
        positions: _objectSpread(_objectSpread({}, state.positions), {}, _defineProperty({}, payload.AccountId, createPositionsMap(payload.data)))
      });
    case _positionActions.SELECT_POSITION:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedProductId: payload
      });
    case _positionActions.RECEIVE_POSITION_EVENT:
      if (state.positions[payload.AccountId]) {
        return _objectSpread(_objectSpread({}, state), {}, {
          positions: _objectSpread(_objectSpread({}, state.positions), {}, _defineProperty({}, payload.AccountId, _objectSpread(_objectSpread({}, state.positions[payload.AccountId]), {}, _defineProperty({}, payload.ProductId, payload))))
        });
      }
      return state;
    default:
      return state;
  }
};
var createPositionsMap = function createPositionsMap(payload) {
  return payload.reduce(function (obj, item) {
    obj[item.ProductId] = item;
    return obj;
  }, {});
};